import { useState, useCallback } from "react"

export const useFamily = () => {
  const [value, setValue] = useState(null)

  const setCurrentValue = useCallback(family => setValue(family), [])

  return { value, setCurrentValue }
}
